"use client";

import { Button } from "@mui/material";
import ErrorComponent from "common/components/errors/error-page";

export default function NotFound() {
	return (
		<ErrorComponent
			title="404: Not Found"
			message="We couldn’t find the page you’re looking for. It may have been moved or deleted."
			buttons={
				<div className="flex-row gap-2">
					<Button variant="contained" href="/">
						Go Home
					</Button>
					<Button variant="outlined" onClick={() => window.history.back()}>
						Go Back
					</Button>
				</div>
			}
		/>
	);
}
